import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';
import { ConfirmComponent } from '../../dialogs/confirm/confirm.component';

import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-notification',
  standalone: true,
  templateUrl: 'notification.component.html',
  styleUrl: 'notification.component.scss',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatSnackBarModule,
    MatInputModule
]
})
export class NotificationComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<NotificationComponent>,
    public dialog: MatDialog,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}

  dismiss() {
    this.snackBarRef.dismiss();
  }

  showDetails() {
    this.dialog.open(ConfirmComponent, { data: { title: 'Error details', message: this.data.details, dismissLabel: "Ok", isDismissOnly: true }});
  }
}
